// extracted by mini-css-extract-plugin
export default {"tabs-wrapper":"advicesBxQ30P","tabs-container":"advicesCzk2cx","tabs-border":"advicesDT3Bnf","tabs-underline":"advices3bAiUe","tab":"advicesPeziZL","tab--active":"advicesVUGbkU"};